import { blokkoColors } from "./blokkoColors";

/** Payment invoice status chips — distinct from KYC palette (purple/blue tones). */
export const PAYMENT_STATUS_CHIP = {
  P: {
    label: "Pending",
    sx: {
      bgcolor: blokkoColors.taglinePeriwinkle,
      color: blokkoColors.entity.iso.text,
      fontWeight: 600,
    },
  },
  E: {
    label: "Executed",
    sx: {
      bgcolor: blokkoColors.entity.merchant.bg,
      color: blokkoColors.primaryDark,
      fontWeight: 600,
    },
  },
};

/** KYC verification status — green / red / amber. */
export const KYC_STATUS_CHIP_SX = {
  approved: {
    bgcolor: "#E8F5E9",
    color: "#1B5E20",
    fontWeight: 600,
  },
  rejected: {
    bgcolor: "#FFEBEE",
    color: blokkoColors.logoRed,
    fontWeight: 600,
  },
  pending: {
    bgcolor: "#FFF3E0",
    color: "#E65100",
    fontWeight: 600,
  },
};

/** POI (document) status — outlined-style fills to differentiate from KYC Status column. */
export const POI_STATUS_CHIP_SX = {
  accepted: {
    bgcolor: "#E8F5E9",
    color: "#1B5E20",
    fontWeight: 600,
    border: "1px solid #A5D6A7",
  },
  rejected: {
    bgcolor: "#FFEBEE",
    color: blokkoColors.logoRed,
    fontWeight: 600,
    border: `1px solid ${blokkoColors.logoRed}`,
  },
  pending: {
    bgcolor: "#FFF8E1",
    color: "#F57C00",
    fontWeight: 600,
    border: "1px solid #FFE082",
  },
  default: {
    bgcolor: blokkoColors.taglineMist,
    color: "#494551",
    fontWeight: 600,
    border: `1px solid ${blokkoColors.taglinePeriwinkle}`,
  },
};

export const DEFAULT_STATUS_CHIP_SX = {
  bgcolor: blokkoColors.taglineMist,
  color: "#494551",
  fontWeight: 600,
};
